var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-checkbox.ts
import "@adornis/base/utilTypes.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { inputToken } from "@adornis/chemistry/elements/theming/input-token.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { FormField } from "@adornis/formfield/form-field.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
var XCheckbox = class extends FormField {
  constructor() {
    super(...arguments);
    this.value = new RXController(this, false);
    this.label = "";
  }
  get inputToken() {
    return inputToken(this);
  }
  styles() {
    return [
      {
        ":host": { userSelect: "none" },
        ":host([error]) x-flex > x-flex": { borderColor: this.colors.tone.error + " !important" },
        "#circle": {
          width: "22px",
          height: "22px",
          borderRadius: this.sizes.borderRadius,
          transition: "backgroundColor .12s, color .12s",
          background: this.value.value ? this.colors.accent : this.colors.neutral.shade(100),
          color: this.value.value ? this.colors.on.accent : "unset",
          border: this.inputToken.border
        },
        ":host([disabled])": { filter: "grayscale(.7)", opacity: 0.7 }
      }
    ];
  }
  render() {
    return xComponents(html`
      <x-flex
        tabindex="0"
        horizontal
        space="sm"
        crossaxis-center
        ${css({ cursor: this.disabled ? "initial" : "pointer" })}
        @keyup=${(e) => {
      if (e.key === "Enter")
        this._toggle();
    }}
        @click=${() => this._toggle()}
      >
        ${this._circle()}
        ${this.label ? html`
              <x-text tone=${this.error || this.getAttribute("error") === "" ? "error" : ""}> ${this.label} </x-text>
            ` : nothing}
      </x-flex>
    `);
  }
  _circle() {
    return html`
      <x-flex horizontal center crossaxis-center flex-none id="circle">
        ${this.value.value ? html` <x-icon> check </x-icon> ` : !this.booleanOnly && typeof this.value.value !== "boolean" ? html` <x-icon> question_mark </x-icon> ` : nothing}
      </x-flex>
    `;
  }
  _toggle() {
    if (!this.disabled) {
      this.value.next(!this.value.value);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
    }
  }
};
__decorateClass([
  property()
], XCheckbox.prototype, "label", 2);
__decorateClass([
  property({ attribute: "boolean-only", type: Boolean })
], XCheckbox.prototype, "booleanOnly", 2);
XCheckbox = __decorateClass([
  customElement("x-checkbox")
], XCheckbox);
export {
  XCheckbox
};
